// client/src/pages/DiscoverHistory.jsx - 浏览历史
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import request from '../utils/request';

const VIEWED_KEY = 'discover_viewed';

function DiscoverHistory() {
  const [viewed, setViewed] = useState([]);
  const [matchedIds, setMatchedIds] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const list = JSON.parse(localStorage.getItem(VIEWED_KEY) || '[]');
    setViewed(list);
    request({ url: '/api/match-history', method: 'GET' })
      .then((res) => {
        const data = res.data || [];
        const ids = new Set(
          data.filter((r) => r.status === 'agreed').map((r) => r.other_user_id)
        );
        setMatchedIds(ids);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const formatItem = (u) => {
    const birthYear = u.birthday ? u.birthday.slice(2, 4) : null;
    const parts = [birthYear ? `${birthYear}年` : null, u.height ? `${u.height}cm` : null, u.job].filter(Boolean);
    return parts.join(' ');
  };

  if (loading) {
    return (
      <Layout>
        <div className="loading">加载中...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div style={{ marginBottom: 16 }}>
        <button className="btn btn-secondary" onClick={() => navigate('/discover')} style={{ padding: '10px 12px' }}>
          ← 返回
        </button>
      </div>
      <h2 style={{ marginBottom: 20 }}>📜 浏览历史</h2>

      {viewed.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: 40 }}>
          <p style={{ color: '#999' }}>暂无浏览记录</p>
          <button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/discover')}>
            去发现
          </button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {viewed.map((u) => (
            <div
              key={u.id}
              className="card"
              onClick={() => navigate(`/discover/viewed/${u.id}`)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                cursor: 'pointer',
              }}
            >
              <img
                src={u.avatar || 'https://via.placeholder.com/48'}
                alt={u.nickname}
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <h3 style={{ fontSize: 16, margin: 0 }}>{u.nickname}</h3>
                  {matchedIds.has(u.id) && (
                    <span
                      style={{
                        fontSize: 11,
                        padding: '2px 8px',
                        borderRadius: 10,
                        background: '#e8f5e9',
                        color: '#4caf50',
                      }}
                    >
                      已牵线
                    </span>
                  )}
                </div>
                <p style={{ color: '#888', fontSize: 13, marginTop: 4, marginBottom: 0 }}>
                  {formatItem(u) || '资料未完善'}
                </p>
              </div>
              <span style={{ color: '#999', fontSize: 14 }}>→</span>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}

export default DiscoverHistory;
